import { Session } from "../../../shared/models";
import { useAuthQuery as useQuery } from '../../../shared/hooks/useAuthQuery';
import { api } from "../../../convex/_generated/api";
import { Id } from "../../../convex/_generated/dataModel";
import { useContext, useMemo } from "react";
import { BaseContext } from "../../../shared/base-context";
import { useStableQuery } from "../../../shared/hooks/useStableQuery";

export const useFetchSessionById = (id: string, isPersonalAssistant: boolean = false) =>  {
    const { convexUserId } = useContext(BaseContext);
    
    const queryArgs = useMemo(() => {
        if (!id || !convexUserId) return "skip";
        return {
            session_id: id as Id<"sessions">,
            is_personal_assistant: isPersonalAssistant,
            user_id: convexUserId as Id<"users">
        };
    }, [id, isPersonalAssistant, convexUserId]);

    return useStableQuery(api.sessions.getSessionById, queryArgs) as Session;
};